import React, { Component } from 'react';
import 'whatwg-fetch';

class Authors extends Component {
	constructor(){
		super();
		this.state = {
			authors:[]
		}
		this.getAuthors = this.getAuthors.bind(this);
		this.toggleMore = this.toggleMore.bind(this);
	}
	
	componentDidMount(){
		this.getAuthors();
	}
	
	getAuthors(){
		const { authors, api } = this.props;
		
		let that = this;
		let apiLabel = ( authors ? 'getAssignedAuthors' : api )
		
		let params = {
				authors:authors
			};
		let formData = new FormData();
		for (var k in params) {
			if(params.hasOwnProperty(k)){
				formData.append(k, params[k]);
			}
		}
		
		fetch('/wp-json/she-rest-api/' + apiLabel + '/',{
			method:"POST",
			body:formData
			}).then(function(res){ 
				return res.json(); 
			})
			.then(function(response){
				let arr = response;
				that.setState({ authors:arr });
				
			}).catch(function(error){
				 console.log(error);
			});
	}
	
	findPos(obj) {
		var curtop = 0;
		if (obj.offsetParent) {
			do {
				curtop += obj.offsetTop;
			} while (obj = obj.offsetParent);
		return curtop;
		}
	}
	
	dimension(elm) {
		var elmHeight, elmMargin;
		if(document.all) {// IE
			elmHeight = elm.currentStyle.height;
			elmMargin = parseInt(elm.currentStyle.marginTop, 10) + parseInt(elm.currentStyle.marginBottom, 10) + "px";
		} else {// Mozilla
			elmHeight = document.defaultView.getComputedStyle(elm, '').getPropertyValue('height');
			elmMargin = parseInt(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-top')) + parseInt(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-bottom')) + "px";
		}
		return { height:elmHeight, margin:elmMargin };
	}
	
	
	toggleMore(e){
		const { wrap } = this.props
		
		let elm = e.currentTarget;
		let tmpElm = elm.getElementsByTagName('span');
		let authorWrap = wrap;
		let that = this;
		
		for(let i=0; i<tmpElm.length; i++){
			if(tmpElm[i].className.indexOf('active')!=-1){
				tmpElm[i].className = '';
			}else{
				tmpElm[i].className = 'active';
				authorWrap.className = authorWrap.className=='showall' ? '' : 'showall';
				setTimeout(function(){
					window.scroll(0,that.findPos(wrap)-that.dimension(document.getElementById('top-navigation')));
				},100);
			}
		}
	}
	
	render(){
		const { authors } = this.state;
		const { wrap, showall } = this.props
		
		let moreBtn = '';
		let authorWrap = wrap;
		
		if(showall){
			authorWrap.className = 'showall';
		}else{
			moreBtn = <div className="author-box-more Abel text-center" onClick={this.toggleMore} >
							<span className="active">more <i className="icon-down-dir"></i></span>
							<span>less <i className="icon-up-dir" ></i></span>
						</div>
		}
		
		if(authors.length){
			return (
				<div>
					{
						authors.map(function(item,index){							
							return (
								<div key={index} className="author-item">
									<div className="thumb-author">
										<div className="thumb-author_pic text-center" style={{ backgroundImage:'url('+item.data.avatar_url+')' }} >
											<a href={item.data.blog.path}></a>
											{
												(item.data.isVip==1 ? 
												<div className="blogger-tick"></div> :
												'')
											}
										</div>
										<div className="thumb-author_name text-center">{ item.data.display_name }</div>
									</div>
								</div>
							)
						})
					}
					{moreBtn}
				</div>
			)
		}else{
			return <div></div>;
		}
	}
}

export default Authors


// WEBPACK FOOTER //
// ./src/Authors.js